import React from 'react';
import packageJson from '../package.json';

global.appVersion = packageJson.version;

const checkVersionMismatch = (latestVersion, currentVersion) => {
    const a = Number(latestVersion);
    const b = Number(currentVersion);

    if (a === b)
        return false;
    
    return a > b || isNaN(b);
};

class HandleCache extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isLatestVersionAvailable: false,
            clearCacheAndReload: () => {
                if (caches) {
                    caches.keys().then(function (names) {

                        for (let name of names) caches.delete(name);

                    });
                }
                window.location.reload(true);
            }
        };
    }

    componentDidMount() {
        fetch('meta.json?' + new Date().getTime().toString(), { cache: 'no-cache' })
            .then((response) => response.json())
            .then((meta) => {
                const latestVersion = meta.version;
                const currentVersion = global.appVersion;
                const shouldForceRefresh = checkVersionMismatch(latestVersion, currentVersion);
                if (shouldForceRefresh) {
                    this.setState({ isLoading: false, isLatestVersionAvailable: true });
                } else {
                    this.setState({ isLoading: false, isLatestVersionAvailable: false });
                }
            });
    }

    render() {
        const { isLoading, isLatestVersionAvailable, clearCacheAndReload } = this.state;
        return this.props.children({ isLoading, isLatestVersionAvailable, clearCacheAndReload });
    }
}

export default HandleCache;